var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-1266.000000, -1134.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form/Input/Date-Copy",
    transform: "translate(1185.000000, 1097.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3299473,37.2500328 C93.611187,37.2500328 97.0799288,40.7187745 97.0799288,45.0000143 C97.0799288,49.2812541 93.611187,52.7499958 89.3299473,52.7499958 C85.0487075,52.7499958 81.5799657,49.2812541 81.5799657,45.0000143 C81.5799657,40.7187745 85.0487075,37.2500328 89.3299473,37.2500328 Z M89.3299473,51.2499994 C92.783064,51.2499994 95.5799324,48.4531311 95.5799324,45.0000143 C95.5799324,41.5468975 92.783064,38.7500292 89.3299473,38.7500292 C85.8768305,38.7500292 83.0799622,41.5468975 83.0799622,45.0000143 C83.0799622,48.4531311 85.8768305,51.2499994 89.3299473,51.2499994 Z M91.2611865,47.987495 L88.6080862,46.059399 C88.5111931,45.9874997 88.4549493,45.8750122 88.4549493,45.7562686 L88.4549493,40.6250247 C88.4549493,40.4187874 88.6237111,40.2500256 88.8299484,40.2500256 L89.8299461,40.2500256 C90.0361834,40.2500256 90.2049452,40.4187874 90.2049452,40.6250247 L90.2049452,45.0531453 L92.2924341,46.5718795 C92.4611959,46.6937664 92.4955586,46.9281408 92.3737022,47.0968721 L91.7861792,47.9062574 C91.6643228,48.0718759 91.4299484,48.1093819 91.2611865,47.987495 Z",
    id: "\\uF017"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.106b0ff3.svg";
export { ForwardRef as ReactComponent };